import React from "react";
import PropTypes from "prop-types";

/**
 * Page/section header. Focus outline removed per a11y rationale (element is focused on route for screen readers).
 * Ported from GSA openacr-editor Header.svelte.
 */
export default function Header({ children }) {
  return (
    <h1>
      {children}
    </h1>
  );
}

Header.propTypes = {
  children: PropTypes.node.isRequired,
};
